export const getLoginStatus = ({ auth }) => {
  return auth.isLoggedIn;
};


export const getPageLoaderStatus = ({ auth }) => {
  return auth.isProgressLoader;
};

export const getLoggedUsername = ({ auth }) => {
  return auth.loggedInUsername
}

export const getLoggedInUserId = ({ auth }) => {
  return auth.loggedInUserId
}

export const getLoggedInUserFirstName = ({ auth }) => {
  return auth.firstName
}

export const getLoggedInUserLastName = ({ auth }) => {
  return auth.lastName
}

export const getUserDetails = ({ auth }) => {
  return auth
}
